import * as React from "react";
import {Field, reduxForm, InjectedFormProps} from 'redux-form'
import {AppState} from "../../../store/app_state";
import {Action, Dispatch} from "redux";
import {connect} from "react-redux";
import * as Validator from "../../../../util/validation";

import Assets from "../../../assets/img/assets";
import FormFieldWrapper from "../../../common/atom/wrapper/form_field_wrapper";
import FormGroupInputConnectRf from "../../../common/molecular/form_group/form_group_input_connect_rf";
import SubmitButtonWrapper from "../../../common/atom/wrapper/submit_btn_wrapper/submit_btn_wrapper";
import BtnCorporateLarge from "../../../common/atom/btn/btn_corporate_large";
import ParagraphSup from "../../../common/atom/text/paragraph_sup";
import {AuthFormImg, AuthFormTitle, LoginFormWrapper} from "../share/auth_share_components";

const validate = (values: any) => {
    const errors: any = {};
    return errors
};

interface IProps extends InjectedFormProps<FormData, {}> {
}

interface IState {
}

export class PasswordResetForm extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {};

    };

    public render(): JSX.Element {

        const {} = this.props;

        const {handleSubmit, pristine, submitting,} = this.props;

        return (
            <LoginFormWrapper>

                <AuthFormTitle>
                    パスワードをリセット
                </AuthFormTitle>

                <AuthFormImg src={Assets.password_reset}/>

                <ParagraphSup>
                    パスワードリセットを行います。登録されたメールアドレスを入力ください。
                    その後メールにパスワードリセットの案内が送付されます。
                </ParagraphSup>

                <form
                    name="passwordResetForm"
                    onSubmit={handleSubmit}>

                    <FormFieldWrapper>
                        <Field
                            label="メールアドレス"
                            placeholder="入力してください"
                            name="email"
                            component={FormGroupInputConnectRf}
                            type="text"
                            validate={[Validator.email, Validator.required]}
                            require={true}
                        />
                    </FormFieldWrapper>

                    <SubmitButtonWrapper>
                        <BtnCorporateLarge
                            name="passwordResetForm-submit"
                            type="submit"
                            widthSize="200px"
                            disabled={pristine || submitting}>パスワードをリセット</BtnCorporateLarge>
                    </SubmitButtonWrapper>

                    <ParagraphSup>© 2019 Libera Inc.</ParagraphSup>
                </form>
            </LoginFormWrapper>
        )
    };

}

const mapStateToProps = (state: AppState) => {
    return {};
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
    return {};
};


export default reduxForm({
        form: 'passwordResetForm',
        validate,
    }
)(connect(mapStateToProps, mapDispatchToProps)(PasswordResetForm));



// WEBPACK FOOTER //
// ./src/presentation/component/auth/password_reset/auth_password_reset_form.tsx